/**
 * Öğretmen girişi: e-posta + kod.
 *
 * Parola yok. Okul tarafına parola açmak, unutulan parolaları
 * sıfırlamak ve okul bilgisayarında kayıtlı kalan parolalarla
 * uğraşmak demekti; kod her girişte yeniden gidiyor.
 *
 * Kayıt bulunup bulunmadığı EKRANDA BELLİ OLMUYOR — sunucu da aynı
 * cevabı veriyor. "Bu e-posta kayıtlı değil" demek, bir öğretmenin bu
 * merkezle ilişkisi olup olmadığını soran herkese söylemek olurdu.
 */

import { useState } from 'react'
import { ApiHatasi, KAPI_ADI, api, type Kapi, type Ogretmen } from '../api'

export function Giris({ kapi, onGiris }: { kapi: Kapi; onGiris: (o: Ogretmen) => void }) {
  const [adim, setAdim] = useState<'eposta' | 'kod'>('eposta')
  const [eposta, setEposta] = useState('')
  const [kod, setKod] = useState('')
  const [maske, setMaske] = useState('')
  const [hata, setHata] = useState<string | null>(null)
  const [bekliyor, setBekliyor] = useState(false)

  const kodIste = async (e: React.FormEvent) => {
    e.preventDefault()
    setHata(null)
    setBekliyor(true)
    try {
      const r = await api.kodIste(eposta.trim())
      setMaske(r.maske)
      setAdim('kod')
    } catch (x) {
      setHata(
        x instanceof ApiHatasi && x.kod === 'cok_fazla_istek'
          ? 'Çok fazla deneme oldu. Biraz bekleyip tekrar deneyin.'
          : 'Kod gönderilemedi. Az sonra tekrar deneyin.',
      )
    } finally {
      setBekliyor(false)
    }
  }

  const giris = async (e: React.FormEvent) => {
    e.preventDefault()
    setHata(null)
    setBekliyor(true)
    try {
      const r = await api.giris(eposta.trim(), kod.trim(), kapi)
      onGiris(r.ogretmen)
    } catch (x) {
      if (x instanceof ApiHatasi && x.kod === 'yanlis_kapi') {
        const ad = String(x.ek?.['turAdi'] ?? '')
        setHata(
          `Bu e-posta ${ad.toLocaleLowerCase('tr-TR')} olarak kayıtlı. ` +
            `Lütfen ${x.ek?.['tur'] === 'counselor' ? 'rehber' : 'ogretmen'}.nirengi adresinden girin.`,
        )
      } else if (x instanceof ApiHatasi && x.kod === 'birden_fazla_merkez') {
        setHata(
          'Bu e-posta birden fazla merkezde kayıtlı. Hangi merkez için ' +
            'gireceğinizi belirlemek gerekiyor; merkezle görüşmeniz gerekir.',
        )
      } else if (x instanceof ApiHatasi && x.kod === 'deneme_bitti') {
        setHata('Deneme hakkı doldu. Yeniden kod isteyin.')
        setAdim('eposta')
        setKod('')
      } else {
        setHata('Kod doğrulanamadı. Kodu kontrol edip tekrar deneyin.')
      }
    } finally {
      setBekliyor(false)
    }
  }

  return (
    <div className="icerik" style={{ maxWidth: 440 }}>
      <h1>Nirengi — {KAPI_ADI[kapi]} girişi</h1>

      {hata && <div className="uyari">{hata}</div>}

      {adim === 'eposta' ? (
        <form className="kart" onSubmit={kodIste}>
          <p className="alt" style={{ marginTop: 0 }}>
            Merkezin size tanımladığı e-posta adresini yazın. Tek kullanımlık bir giriş kodu
            göndereceğiz.
          </p>
          <label>
            E-posta
            <input
              type="email"
              value={eposta}
              onChange={(ev) => setEposta(ev.target.value)}
              required
              autoFocus
              autoComplete="email"
            />
          </label>
          <button className="birincil" type="submit" disabled={bekliyor}>
            {bekliyor ? 'Gönderiliyor…' : 'Kod gönder'}
          </button>
        </form>
      ) : (
        <form className="kart" onSubmit={giris}>
          <p className="alt" style={{ marginTop: 0 }}>
            Kod <strong>{maske}</strong> adresine gönderildi. Kayıt bulunamadıysa e-posta
            gelmez; adresi kontrol edip baştan deneyebilirsiniz.
          </p>
          <label>
            Giriş kodu
            <input
              inputMode="numeric"
              pattern="[0-9]{6}"
              maxLength={6}
              value={kod}
              onChange={(ev) => setKod(ev.target.value.replace(/\D/g, ''))}
              required
              autoFocus
            />
          </label>
          <div className="dugmeler">
            <button className="birincil" type="submit" disabled={bekliyor || kod.length !== 6}
            title={kod.length !== 6 ? 'Kod altı haneli olmalı' : 'Giriş yap'}>
              {bekliyor ? 'Kontrol ediliyor…' : 'Giriş yap'}
            </button>
            <button type="button" onClick={() => setAdim('eposta')} disabled={bekliyor}>
              Adresi değiştir
            </button>
          </div>
        </form>
      )}

      <p className="alt">
        Bu ekran gözlem formu doldurmak ve haftalık takip sayısı girmek için. Öğrencinin
        dosyası, raporu ve ölçüm sonuçları burada görünmez.
      </p>
    </div>
  )
}
